import styled from 'styled-components';
import PropTypes from 'prop-types';

// eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
const ico = `<?xml version="1.0" encoding="UTF-8"?> <svg version="1.1" viewBox="0 0 10 9" xmlns="http://www.w3.org/2000/svg"> <g fill="none" fill-rule="evenodd"> <g transform="translate(-678 -319)" fill="%23FDBD20"> <g transform="translate(48 295)"> <g transform="translate(597 24)"> <polygon points="37.924 7.0903 35.146 8.551 35.676 5.4572 33.429 3.2662 36.535 2.8148 37.924 0 39.313 2.8148 42.42 3.2662 40.172 5.4572 40.703 8.551"/> </g> </g> </g> </g> </svg>`;

const StarsIco = styled.div`
    background-repeat: repeat-x;
    background-image: url('data:image/svg+xml;charset=UTF-8,${ico}');
    background-size: 10px 9px;
    height: 9px;
    width: ${(props) => {
      const { stars } = props;
      return stars && stars !== 0 ? stars * 10 : 0;
    }}px;
    display: inline-block;
`;

StarsIco.propTypes = {
  stars: PropTypes.number,
  className: PropTypes.string,
};

StarsIco.displayName = 'StarsIco';

export default StarsIco;
